const dashboardSections = {
  summary: 'summary',
  forum: 'forum'
}

export default dashboardSections
